import { ElementRef, inject, Injectable, NgZone } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HoverHighlightService {
	private listeners: (() => void)[] = [];

	private readonly ngZone = inject(NgZone);

	bindHoverEvents<
		T extends { id: number; reservation: number; slotVehicle: { vehicle: { id: number }; order: number } },
	>(
		elements: ElementRef[],
		getDataFromElement: (el: HTMLElement) => T,
		findMatchingSlotIds: (vehicleId: number, reservation: number, order: number) => number[],
		onUpdate: (ids: Set<number>) => void,
		cdr: ChangeDetectorRef,
	): void {
		this.ngZone.runOutsideAngular(() => {
			elements.forEach((ref) => {
				const el = ref.nativeElement;

				const enter = () => {
					const data = getDataFromElement(el);
					const ids = new Set(
						findMatchingSlotIds(
							data?.slotVehicle?.vehicle.id,
							data.reservation,
							data?.slotVehicle?.order ?? null,
						),
					);
					this.ngZone.run(() => {
						onUpdate(ids);
						cdr.markForCheck();
					});
				};

				const leave = () => {
					this.ngZone.run(() => {
						onUpdate(new Set());
						cdr.markForCheck();
					});
				};

				el.addEventListener('mouseenter', enter);
				el.addEventListener('mouseleave', leave);

				this.listeners.push(() => {
					el.removeEventListener('mouseenter', enter);
					el.removeEventListener('mouseleave', leave);
				});
			});
		});
	}

	cleanup(): void {
		this.listeners.forEach((unbind) => unbind());
		this.listeners = [];
	}
}
